import { render, staticRenderFns } from "./newlist.vue?vue&type=template&id=1d096d0e&scoped=true&"
import script from "./newlist.vue?vue&type=script&lang=js&"
export * from "./newlist.vue?vue&type=script&lang=js&"
import style0 from "./newlist.vue?vue&type=style&index=0&id=1d096d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d096d0e",
  null
  
)

export default component.exports